module.exports = __webpack_public_path__ + "static/media/beer.02112af8.jpg";